































































































































































import { Component, Vue } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";

const origin = [
	// {
	//     name: "结转材料销售成本",
	//     adjustingType: "jzclxscb"
	// },
	{
		name: "结转生产领料",
		adjustingType: "jzscll",
	},
	{
		name: "结转制造费用",
		adjustingType: "jzzzfy",
	},
	{
		name: "结转完工入库成本",
		adjustingType: "jzwgrkcb",
	},
];
@Component({
	components: {
		"month-selector": MonthSelectorVue,
	},
})
export default class InventoryAdjusting extends Vue {
	period = "";
	isInit = 2;
	title = "";

	dataList: Adjusting.Adjusting[] = origin;
	async changeDate(date: string) {
		this.period = date;
		this.isInit = 2;
		this.fetchData();
	}

	clickAmount() {
		this.isInit = 1;
		this.fetchData();
	}

	async fetchData() {
		const res = await Vue.axios.post(`adjusting`, {
			accountBookId: this.$store.state.accountBook.id,
			endPeriod: this.period,
			isInit: this.isInit,
			isInventory: true,
		});
		this.title = res.data.text;
		this.dataList.forEach(e => {
			if (e.adjustingType) Object.assign(e, res.data[e.adjustingType]);
		});
		this.$forceUpdate();
	}

	//生成凭证
	createPZ(voucher: Voucher.Voucher) {
		this.voucherVisible = true;
		this.$nextTick(function () {
			let newVoucher: any = this.$refs.newVoucher;
			this.fetchVoucher();
			newVoucher.isInsert = 0;
			newVoucher.isEdit = false;
			newVoucher.isDialog = true;
			newVoucher.showSaveAndAdd = false;
			newVoucher.showAdd = false;
			newVoucher.isCheck = true;
			newVoucher.shouldGetInit = false;
			newVoucher.getSubjectList(null, () => {
				newVoucher.packVoucher(voucher);
			});
		});
	}

	//查看凭证
	voucherVisible: boolean = false;
	async viewVoucher(id: number | null) {
		const res = await Vue.axios.post(`voucher/` + id + `/find`, {});
		this.voucherVisible = true;
		this.$nextTick(() => {
			let newVoucher: any = this.$refs.newVoucher;
			this.fetchVoucher();
			newVoucher.isDialog = true;
			newVoucher.isInsert = 0;
			newVoucher.showSaveAndAdd = false;
			newVoucher.showAdd = false;
			newVoucher.isCheck = true;
			newVoucher.shouldGetInit = false;
			newVoucher.getSubjectList(null, () => {
				newVoucher.packVoucher(res.data);
			});
		});
	}
	fetchVoucher() {
		this.$nextTick(function () {
			let newVoucher: any = this.$refs.newVoucher;
			if (
				Number(this.period) <=
				Number(this.$store.state.accountBook.closePeriod)
			) {
				newVoucher.isClose = true;
			} else {
				newVoucher.isClose = false;
			}
		});
	}
	//关闭凭证MODAL
	closeVoucher() {
		let newVoucher: any = this.$refs.newVoucher;
		this.voucherVisible = false;
		this.fetchData();
		newVoucher.resetVoucher();
	}
	// 更新
	async update(item: Adjusting.Adjusting) {
		await Vue.axios.post(
			`adjusting/update?voucherId=${item.voucherId}&adjustingType=${item.adjustingType}`,
			{ nothing: "" }
		);
		this.fetchData();
	}

	// 修改气泡窗内的texts.per
	async perClick(text: Adjusting.Text) {
		let keyword = "";
		if (text.text) {
			if (text.text === "2.结转百分比：") {
				keyword = "CARRY_PERCENTAGE";
			} else if (text.text === "2.所得税税率：") {
				keyword = "INCOME_TAX_RATE";
			} else if (text.text === "2.应交城市维护建设税税率：") {
				keyword = "CITY_FEE_RATE";
			} else if (text.text === "3.教育费附加税率：") {
				keyword = "EDUCATION_FEE_RATE";
			} else if (text.text === "4.地方教育费附加税率：") {
				keyword = "LOCAL_EDUCATION_FEE_RATE";
			} else if (text.text === "3.印花税税率：") {
				keyword = "STAMP_TAX_PERCENTAGE";
			} else {
				keyword = text.text.replace(/汇率：/g, "");
			}
		}
		await Vue.axios.post(`systemsettings/save`, {
			accountBookId: this.$store.state.accountBook.id,
			keyword: keyword,
			value: text.per,
		});
		await this.fetchData();
		this.$forceUpdate();
	}
}
